import { selectWidgetTitle, selectWidgetTitleFontSize } from 'app/imports/App.selectors'
import IconLogo from 'assets/img/logo_small.png'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import * as Styled from './LayoutHeader.styled'

export function LayoutHeader() {
  const widgetTitle = useSelector(selectWidgetTitle)
  const widgetTitleFontSize = useSelector(selectWidgetTitleFontSize)

  const title = useMemo(() => {
    return widgetTitle || ''
  }, [widgetTitle])

  return (
    <Styled.HeaderContainer>
      <title>Team Schedules Widget</title>

      <Styled.TitleContainer>
        <Styled.LabelContainer>
          <Styled.Label>Presented by CSZ Network</Styled.Label>
          <Styled.Logo src={IconLogo} alt="" />
        </Styled.LabelContainer>

        <Styled.Title $size={widgetTitleFontSize}>{title}</Styled.Title>
      </Styled.TitleContainer>
    </Styled.HeaderContainer>
  )
}
